import React, { FC } from 'react';

export interface Tab {
  id: number | string;
  title: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}

interface TabsProp {
  tabs: Tab[];
  selectedTab: string;
  onTabSelect: (tab: string) => void;
  className?: string;
  tabStyle?: string;
  tabBlurredState?: string;
  hasCount?: boolean;
  countMap?: Record<string, number>;
}

const Tabs: FC<TabsProp> = props => {
  const {
    tabs,
    selectedTab,
    onTabSelect,
    tabStyle,
    className,
    tabBlurredState = 'opacity-75',
    hasCount,
    countMap
  } = props;
  return (
    <div className={`flex ${className}`}>
      {tabs.map(tab => (
        <div
          id={`${tab.title}-tab`}
          key={tab.id}
          role="presentation"
          onClick={() => onTabSelect(tab.title)}
          className={`remove-highlight flex min-w-[93px] cursor-pointer justify-center py-1.5 text-17px 
          font-semibold normal-case leading-5 text-primaryText ${tabStyle}
          ${selectedTab === tab.title ? 'border-b-2 border-secondaryBtnText opacity-100' : tabBlurredState}`}>
          {tab.icon && tab.iconPosition === 'left' && <span className="mr-2">{tab.icon}</span>}
          {hasCount ? `${tab.title} (${countMap[tab.title]})` : tab.title}
          {tab.icon && tab.iconPosition === 'right' && <span className="ml-2">{tab.icon}</span>}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
